import { createSlice } from '@reduxjs/toolkit'
import reducers from 'store/features/cache/reducers'
import { getInitialState } from 'store/features/cache/initialState'

const cacheSlice = createSlice({
  name: 'cache',
  initialState: getInitialState(),
  reducers
})

export default cacheSlice
